module.exports = __webpack_public_path__ + "static/media/finekralogo_white.fc59c29c.png";